import header from './header';
import footer from './footer';

export default {
  loading: 'Загрузка сообщений...',
  empty: 'Нет сообщений',
  chat_not_select: 'Выберите чат',

  no_more_message: 'Больше нет сообщений',

  status: {
    new: 'Новый',
    chat: 'Чат',
    resolved: 'Решено',
  },

  message_email: {
    add: 'Сохранить как Email контакта',
  },

  play_video: 'Воспроизвести видео',
  download_file: 'Скачать файл',

  header,
  footer,
};
